import React from 'react'

export default function FilterBtn({ text, active, index, setActiveTab, onClick }) {
    const activate = () => {
        setActiveTab(index)
    }

    return (
        <button onClick={() => {
            activate()
            onClick()
        }} className={(active == index) ? "btn-primary-active" : 'btn-primary'}>
            {text}
        </button>
    )
}